import type { ComponentProps } from 'react';
import { Link } from '../Link';

/**
 * Sites we publish ourselves, plus link-exchange partners we vouch for by agreement.
 * A partner link that renders nofollow is not the link the partner agreed to.
 */
const FOLLOWED_HOSTS = new Set([
  'serpprices.com',
  'www.serpprices.com',
  'xtwitterapiprices.com',
  'www.xtwitterapiprices.com',
  'scrapeprices.com',
  'www.scrapeprices.com',
  'gmplus.io',
  'www.gmplus.io',
  'eseospace.com',
  'www.eseospace.com',
]);

const isFollowed = (href: string) => {
  try {
    return FOLLOWED_HOSTS.has(new URL(href).hostname);
  } catch {
    return false;
  }
};

/** MDX `a` override: internal hrefs use the router; external/anchor fall back to <a>. */
export const MdxLink = ({ href, children, ...rest }: ComponentProps<'a'>) => {
  if (!href) return <a {...rest}>{children}</a>;
  const external = /^https?:/.test(href);
  const rel = isFollowed(href) ? 'noopener noreferrer' : 'noopener noreferrer nofollow';
  return (
    <Link to={href} {...(external ? { target: '_blank', rel } : {})} {...rest}>
      {children}
    </Link>
  );
};
